module.exports = __webpack_public_path__ + "static/img/action.d2aff09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation/action.svg
// module id = PgF6
// module chunks = 46